import SectionBlock, { SectionHeading, Edit as SectionEdit, Add as SectionAdd } from './SectionBlock';

export { SectionHeading, SectionEdit, SectionAdd };
export default SectionBlock;
